import React, { FC, useState } from 'react';
import { MediaPhoto } from '../../PhotoPickerDialog.types';
import { PhotoCropper as PhotoCropperComponent } from '@shared/components/MultiPhotoSelector/components/PhotoCropDialog/PhotoCropDialog';
import { centerCrop, Crop, makeAspectCrop } from 'react-image-crop';
import { ImageData } from '@shared/components/MultiPhotoSelector/MultiPhotoSelector.types';

type PhotoCropperProps = Readonly<{
  selectedPhoto: MediaPhoto;
  aspectRatio?: number;
  crop?: Crop;
  handleCrop: (crop: Crop) => void;
  label?: string;
}>;

export const PhotoCropper: FC<PhotoCropperProps> = props => {
  const { selectedPhoto, crop, aspectRatio, handleCrop, label } = props;

  const imageData: ImageData = {
    id: selectedPhoto.id,
    url: selectedPhoto.photo.url,
    height: selectedPhoto.photo.height,
    width: selectedPhoto.photo.width,
  };

  const [cropData, setCropData] = useState<Crop>(
    () =>
      crop ||
      centerCrop(
        makeAspectCrop(
          {
            unit: '%',
            width: 90,
          },
          aspectRatio || 1,
          imageData.width,
          imageData.height,
        ),
        imageData.width,
        imageData.height,
      ),
  );

  const onCrop = (crop: Crop) => {
    setCropData(crop);
    handleCrop(crop);
  };

  return (
    <PhotoCropperComponent
      imageData={imageData}
      aspectRatio={aspectRatio}
      cropData={cropData}
      setCropData={onCrop}
      maxHeight={350}
      label={label}
    />
  );
};

PhotoCropper.displayName = 'PhotoCropper';
